import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../types/redux';
import { selectPagination } from '../../../selectors/pagination';
import { getTotalCountPages, preparePagination } from '../../../utils/pagination';
import { changePage } from '../../../actions/pagination';
import { IPaginationItem } from '../../../types/pagination';

interface IPagination {
  pages: IPaginationItem[];
  onPageSelect(page: number): void;
  nextPage?: IPaginationItem;
  prevPage?: IPaginationItem;
}

export function usePagination(): IPagination {
  const dispatch = useDispatch<TThunkDispatch>();

  const { page, limit, total } = useSelector(selectPagination, shallowEqual);
  const totalPages = getTotalCountPages(total, limit);

  const onPageSelect = React.useCallback((page: number) => dispatch(changePage(page)), [dispatch]);

  const pages = React.useMemo(() => preparePagination({ currentPage: page, totalPages }), [page, totalPages]);

  const prevPage = React.useMemo<IPaginationItem>(
    () => ({
      disabled: page === 1,
      page: page - 1,
      title: 'Назад',
    }),
    [page],
  );

  const nextPage = React.useMemo<IPaginationItem>(
    () => ({
      disabled: page === totalPages,
      page: page + 1,
      title: 'Дальше',
    }),
    [page, totalPages],
  );

  return React.useMemo(
    () => ({
      nextPage,
      prevPage,
      pages,
      onPageSelect,
    }),
    [nextPage, onPageSelect, pages, prevPage],
  );
}
